import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { FaCheck, FaTimes, FaPlus, FaChartLine } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import businesseservice from "../../../services/business_services"

class AdminBusinessActivities extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activities: [],
            deactivated: false,
            selectKey: null,
            order: 'asc',
            loading: true,
            processing: false,
            name_en: null,
            name_fr: null,
            desc_en: null,
            desc_fr: null,
        }
    }

    componentDidMount = async () => {
        await this.loadActivities()
    }

    loadActivities = async () => {
        this.setState({ loading: true })
        const activities = await businesseservice.businessActivities(this.state.deactivated)
        this.setState({ activities, loading: false })
    }

    switchFilter = async () => {
        this.setState({ deactivated: !this.state.deactivated }, () => this.loadActivities())
    }

    reorder = async (key) => {
        let order = 'asc'
        if (this.state.selectKey === key && this.state.order === 'asc')
            order = 'desc'
        this.setState({ selectKey: key, order })
        let activities = this.state.activities
        if (order === 'asc')
            activities.sort((a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0))
        else
            activities.sort((a, b) => (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0))
        this.setState({ activities })
    }

    activate = async (business_activity_uuid) => {
        try {
            const data = await businesseservice.activateActivity(business_activity_uuid)
            NotificationManager.success(data.message)
            this.loadActivities()
        } catch (e) {
            NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
        }
    }

    deactivate = async (business_activity_uuid) => {
        try {
            const data = await businesseservice.deactivateActivity(business_activity_uuid)
            NotificationManager.success(data.message)
            this.loadActivities()
        } catch (e) {
            NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
        }
    }

    create = async () => {
        if (!this.state.name_en || !this.state.name_fr)
            NotificationManager.error('Missing information')
        else {
            try {
                this.setState({ processing: true })
                const data = await businesseservice.newBusinessActivity(this.state.name_en, this.state.name_fr, this.state.desc_en, this.state.desc_fr)
                NotificationManager.success(data.message)
                this.loadActivities()
                this.setState({ processing: false, name_en: null, name_fr: null, desc_fr: null, desc_en: null  })
            } catch (e) {
                this.setState({ processing: false })
                NotificationManager.error(e.response && e.response.data ? e.response.data.message : e.message)
            }
        }
    }

    render() {
        return (
            <>
                <AdminLayout 
                    title="Business Activities"
                    breadcrumbs={[
                        { label: 'Business', href: '/admin/business' },
                        { label: 'Activities' }
                    ]}
                >
                    <div className="space-y-6">
                        {/* Filter Section */}
                        <div className="bg-gradient-to-br from-gray-50 to-slate-50 rounded-xl p-6 border border-gray-200">
                            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                                <FaChartLine className="text-gray-600" />
                                {this.state.deactivated ? "Deactivated" : "Active"} Business Activities
                            </h3>
                            
                            <button 
                                onClick={this.switchFilter}
                                className={`px-4 py-2 rounded-lg transition-all font-medium shadow-md hover:shadow-lg ${
                                    this.state.deactivated 
                                        ? 'bg-gray-500 text-white hover:bg-gray-600' 
                                        : 'bg-green-500 text-white hover:bg-green-600'
                                }`}
                            >
                                {this.state.deactivated ? 'Show Active Activities' : 'Show Deactivated Activities'}
                            </button>
                        </div>

                        {/* Activities Table */}
                        {this.state.loading ? (
                            <div className="bg-white rounded-xl shadow-md border border-gray-200 p-8 text-center">
                                <p className="text-gray-600">Loading...</p>
                            </div>
                        ) : (
                            <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                                <div className="overflow-x-auto">
                                    <table className="w-full">
                                        <thead className="bg-gradient-to-r from-purple-50 to-indigo-50 border-b border-gray-200">
                                            <tr>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase w-12">#</th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-purple-100 transition-colors w-48" onClick={() => this.reorder("business_name")}>
                                                    ⥃ Name EN
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-purple-100 transition-colors w-48" onClick={() => this.reorder("website")}>
                                                    ⥃ Name FR
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-purple-100 transition-colors" onClick={() => this.reorder("city")}>
                                                    ⥃ Description EN
                                                </th>
                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-purple-100 transition-colors" onClick={() => this.reorder("country")}>
                                                    ⥃ Description FR
                                                </th>
                                                <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase w-24">Status</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200">
                                            {this.state.activities.map((activity, index) => (
                                                <tr key={`activity_${activity.business_activity_uuid}`} className="hover:bg-gray-50 transition-colors">
                                                    <td className="px-4 py-3">
                                                        <span className="font-semibold text-gray-700">{index + 1}</span>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <span className="font-medium text-gray-900">{activity.activity_name?.en}</span>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <span className="font-medium text-gray-900">{activity.activity_name?.fr}</span>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <span className="text-sm text-gray-700">{activity.description?.en}</span>
                                                    </td>
                                                    <td className="px-4 py-3">
                                                        <span className="text-sm text-gray-700">{activity.description?.fr}</span>
                                                    </td>
                                                    <td className="px-4 py-3 text-center">
                                                        {this.state.deactivated ? (
                                                            <button 
                                                                onClick={() => this.activate(activity.business_activity_uuid)}
                                                                className="p-2 bg-green-100 text-green-700 rounded-lg hover:bg-green-200 transition-colors inline-flex items-center justify-center"
                                                                title="Activate"
                                                            >
                                                                <FaCheck />
                                                            </button>
                                                        ) : (
                                                            <button 
                                                                onClick={() => this.deactivate(activity.business_activity_uuid)}
                                                                className="p-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 transition-colors inline-flex items-center justify-center"
                                                                title="Deactivate"
                                                            >
                                                                <FaTimes />
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}

                        {/* Create New Activity Form */}
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                            <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                                <FaPlus className="text-purple-600" />
                                New Business Activity
                            </h3>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Name EN *</label>
                                    <input 
                                        type="text" 
                                        placeholder="English name" 
                                        value={this.state.name_en || ''} 
                                        onChange={(e) => this.setState({ name_en: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Name FR *</label>
                                    <input 
                                        type="text" 
                                        placeholder="French name" 
                                        value={this.state.name_fr || ''} 
                                        onChange={(e) => this.setState({ name_fr: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Description EN</label>
                                    <input 
                                        type="text" 
                                        placeholder="English description" 
                                        value={this.state.desc_en || ''} 
                                        onChange={(e) => this.setState({ desc_en: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none"
                                    />
                                </div>

                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Description FR</label>
                                    <input 
                                        type="text" 
                                        placeholder="French description" 
                                        value={this.state.desc_fr || ''} 
                                        onChange={(e) => this.setState({ desc_fr: e.target.value })}
                                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none"
                                    />
                                </div>
                            </div>

                            <div className="mt-6 flex justify-end">
                                {this.state.processing ? (
                                    <div className="px-6 py-3 bg-gray-100 text-gray-500 rounded-lg">
                                        Processing... Please wait
                                    </div>
                                ) : (
                                    <button 
                                        onClick={this.create}
                                        className="px-6 py-3 bg-gradient-to-r from-purple-500 to-indigo-600 text-white rounded-lg hover:from-purple-600 hover:to-indigo-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                    >
                                        <FaPlus />
                                        Create Activity
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </AdminLayout>
                <NotificationContainer />
            </>
        )
    }
}

export default withTranslation()(AdminBusinessActivities)